import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { FormControlLabel, Checkbox } from '@mui/material';
import { BaseNode } from 'pages/assistants/builder/components/nodes/baseNode';
import { CompactNodeField } from 'pages/assistants/builder/components/nodes/compactNodeField';

export function SimpleMailInputNode({ id, data, handleConf, onEditNode, onDeleteNode }) {
  const { formatMessage: msg } = useIntl();

  return (
    <BaseNode
      id={id}
      icon="mail_icon"
      nodeData={{ ...data, label: 'Email' }}
      color="infoBlue"
      handleConf={handleConf}
      onEditNode={onEditNode}
      onDeleteNode={onDeleteNode}
    >
      <CompactNodeField
        label={msg({ id: 'field.mail.protocol.label' })}
        value={data?.protocol || 'imaps'}
      />
      <CompactNodeField label={msg({ id: 'field.mail.host.label' })} value={data?.hostURI || ''} />
      <CompactNodeField label={msg({ id: 'field.mail.port.label' })} value={data?.port || '993'} />
      {data?.username && (
        <CompactNodeField
          label={msg({ id: 'field.mail.username.label' })}
          value={data?.username || ''}
        />
      )}

      {data?.password && (
        <CompactNodeField label={msg({ id: 'field.mail.password.label' })} value="••••••" />
      )}

      <CompactNodeField label={msg({ id: 'field.mail.delay.label' })} value={data?.delay ?? 5} />
      <FormControlLabel
        control={<Checkbox checked={data?.delete ?? true} />}
        label={msg({ id: 'field.mail.delete.label' })}
      />
    </BaseNode>
  );
}

SimpleMailInputNode.propTypes = {
  id: PropTypes.string,
  data: PropTypes.shape({
    id: PropTypes.number,
    protocol: PropTypes.string,
    hostURI: PropTypes.string,
    port: PropTypes.string,
    username: PropTypes.string,
    password: PropTypes.string,
    delay: PropTypes.number,
    delete: PropTypes.bool
  }),
  handleConf: PropTypes.array.isRequired,
  onEditNode: PropTypes.func.isRequired,
  onDeleteNode: PropTypes.func.isRequired
};
